import React, { useState, useEffect, useRef } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import './logoslider.css';
import { Link } from 'react-router-dom';

const LogoSlider = () => {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null);

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const referencesCollection = collection(db, 'references');
        const snapshot = await getDocs(referencesCollection);
        
        // Filter ud referencer med logoer og som ikke er slettet
        const logoUrls = snapshot.docs
          .filter(doc => {
            const data = doc.data();
            return data.logoUrl && (!data.erSlettet || (data.erSlettet && new Date(data.slettetDato) > new Date()));
          })
          .map(doc => ({
            id: doc.id,
            url: doc.data().logoUrl,
            title: doc.data().title || 'Partner logo',
            cvr: doc.data().cvr || '',
            website: doc.data().website || ''
          }));
        
        setLogos(logoUrls);
      } catch (error) {
        console.error("Fejl ved hentning af logoer:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLogos();
  }, []);

  // Brug placeholders hvis der ikke er nogen logoer endnu
  const placeholderLogos = [
    { id: 'placeholder1', url: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop', title: 'Placeholder logo' },
    { id: 'placeholder2', url: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop', title: 'Placeholder logo' },
    { id: 'placeholder3', url: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop', title: 'Placeholder logo' },
    { id: 'placeholder4', url: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop', title: 'Placeholder logo' },
  ];

  // Brug de faktiske logoer eller placeholders
  const displayLogos = logos.length > 0 ? logos : placeholderLogos;
  
  // For en helt flydende effekt gentager vi logoerne 4 gange
  // Dette sikrer, at der er rigeligt med logoer til at dække displayet
  const repeatedLogos = [...displayLogos, ...displayLogos, ...displayLogos, ...displayLogos];

  return (
    <div className="logo-slider-container">
      <div className="logo-slider">
        <div className="logo-slider-track" ref={sliderRef}>
          {repeatedLogos.map((logo, index) => (
            <div key={`logo-${index}`} className="logo-slide">
              {logo.id.startsWith('placeholder') ? (
                <img src={logo.url} alt={logo.title} />
              ) : (
                <Link 
                  to={`/referencer/${logo.id}`} 
                  title={logo.title + (logo.cvr ? ` • CVR: ${logo.cvr}` : '') + (logo.website ? ` • ${logo.website}` : '')}
                >
                  <img src={logo.url} alt={logo.title} />
                  <div className="logo-info">
                    <h4>{logo.title}</h4>
                    {logo.cvr && <p>CVR: {logo.cvr}</p>}
                    {logo.website && <p>{logo.website}</p>}
                  </div>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoSlider;
